module.exports = __webpack_public_path__ + "img/socialMediaTwitterNavy.3fbacff1.png";